<template>
	<div class="link-toggle" :class="classes" @click="_click" @mousedown="_mousedown" @mouseup="_mouseup">
		<div class="link-toggle-circle"></div>
	</div>
</template>

<script>
import {EditMixin} from "../mixins";

export default {
	name: "link-toggle",
	mixins: [EditMixin],
	props: {
		value: {},
		size: {type: String, default: 'small'},
		color: {type: String, default: 'primary'},

		trueValue: {default: true},
		falseValue: {default: false},
	},
	watch: {
		value(val) {
			val !== this.currentValue && (this.currentValue = val)
		},
		currentValue(val) {
			this.$emit('input', val)
		},
	},
	data() {
		return {
			currentValue: this.value,
			active: false,
		}
	},
	computed: {
		on() {
			return this.currentValue === this.trueValue
		},
		classes() {
			return [
				`link-toggle-color-${this.color}`,
				`link-toggle-size-${this.size}`,
				{
					'link-toggle-on': !!this.on,
					'link-toggle-active': this.active,
					'link-toggle-readonly': this.lv_readonly,
					'link-toggle-disabled': this.lv_disabled,
				}
			]
		},
	},
	methods: {
		_click() {
			if (this.lv_readonly || this.lv_disabled) return
			this.currentValue = !this.on ? this.trueValue : this.falseValue
			this.$emit('change', this.currentValue);
		},
		_mousedown() {
			this.active = true
		},
		_mouseup() {
			this.active = false
		},
	},
}
</script>

<style lang="scss">
@include themeify {
	.link-toggle {
		background-color: #f2f2f2;
		position: relative;
		transition: background-color .3s;
		display: inline-block;
		vertical-align: middle;
		cursor: pointer;
		user-select: none;

		@each $key, $value in $list-size {
			&.link-toggle-size-#{$key} {
				height: $value;
				width: $value*52/32;
				border-radius: $value/2;

				&.link-toggle-on {
					.link-toggle-circle {
						left: $value/2+6;
					}
				}

				.link-toggle-circle {
					right: $value/2+6;
					border-radius: $value/2-2;
				}

				&.link-toggle-active {
					.link-toggle-circle {
						right: $value/2;
					}

					&.link-toggle-on .link-toggle-circle {
						left: $value/2;
					}
				}
			}
		}

		&:before {
			position: absolute;
			left: 2px;
			right: 2px;
			top: 2px;
			bottom: 2px;
			border-radius: 16px;
			background-color: #fff;
			content: "";
			/*transform: scale3d(1, 1, 1);*/
			transform: scaleX(1);
			transition: transform .3s;
		}

		&.link-toggle-on {
			&:before {
				transform: scale3d(0, 0, 0);
			}

			.link-toggle-circle {
				right: 2px;
			}

			@include pl-colors(link-toggle) {
				background-color: $value;
			}

			&.link-toggle-disabled {
				background-color: $color-info;
				cursor: not-allowed;
			}
		}

		.link-toggle-circle {
			position: absolute;
			left: 2px;
			top: 2px;
			bottom: 2px;
			background: white;
			box-shadow: 0 3px 12px rgba(0, 0, 0, .16), 0 3px 1px rgba(0, 0, 0, .1);
			transition: all 0.3s;
		}

		&.link-toggle-active {
			.link-toggle-circle {
				left: 2px;
			}

			&.link-toggle-on .link-toggle-circle {
				right: 2px;
			}
		}
	}
}
</style>
